import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			color: `${theme.palette.error.contrastText} !important`,
		}),
	},
};
